// GET_LIMITED_NOTIFICATIONS
export const GET_LIMITED_NOTIFICATIONS_REQUEST =
  "GET_LIMITED_NOTIFICATIONS_REQUEST";
export const GET_LIMITED_NOTIFICATIONS_SUCCESS =
  "GET_LIMITED_NOTIFICATIONS_SUCCESS";
export const GET_LIMITED_NOTIFICATIONS_FAIL = "GET_LIMITED_NOTIFICATIONS_FAIL";
